<template>
  <v-dialog v-model="show" persistent max-width="450">
    <v-card>
      <v-card-title>{{editType?'Update':'Create'}} equipment type</v-card-title>
      <v-divider/>
        <v-form v-model="valid" immediate ref="form">
          <v-container class="mt-2">
            <v-row>
              <v-col>
                <v-text-field label="Name" v-model="equipmentType.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" outlined dense :counter="50"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
        <v-btn color="primary" @click="create()" :loading="busy">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'EquipmentTypesQuickCreate',
	props: {
    value: {type:Boolean,required:true},
    editType: {type:Object, required: false}
  },
  data() {
    return {
      valid: true,
      show: false,
      equipmentType: {name:''},
      busy: false
    }
  },
  watch: {
    value() {
      if (!this.editType)
        this.equipmentType.name = '';
      this.show = this.value;
    },
    editType: {
      handler() {
        this.equipmentType = {...this.editType};
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.busy = true;
      const results = await this.$apiCall(`mutation EquipmentTypesQuickCreate($input: EquipmentTypeInput!) {
                                            equipmentTypeCreate(input:$input) {id,name}
                                          }`,
                                          {input:this.equipmentType});
      this.busy = false;
      if (!results.error) {
        this.show = false;
        this.$emit('input', false);
        this.$emit('create',results.data.equipmentTypeCreate);
      }
    },
  }
}
</script>
